import { IconBaseType } from "@/v2-components/core/icon/type";
import { cn } from "@/libs/utils";

export default function RefreshIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
    >
      <path
        d="M18.9216 13.05C18.4148 16.4177 15.5091 19 12 19C8.13385 19 4.99994 15.8661 4.99994 12C4.99994 8.13391 8.13385 5 12 5C14.87 5 17.3375 6.72761 18.4176 9.20001M15.5 9.2H18.58C18.6352 9.2 18.6898 9.18913 18.7408 9.16802C18.7917 9.14692 18.838 9.11598 18.877 9.07698C18.916 9.03798 18.947 8.99168 18.9681 8.94072C18.9892 8.88976 19 8.83515 19 8.77999V5.69999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
